import {Component, OnInit, Input, Output, EventEmitter, OnChanges} from '@angular/core';

@Component({
  selector: 'leap-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.less']
})
export class TabsComponent implements OnInit {

  @Input() tabs: { value: string, displayValue: string, disabled: boolean }[];
  @Output() tabSelect: EventEmitter<string> = new EventEmitter()

  @Input() selectedTab;

  constructor() { }

  ngOnInit() {
  }
  selectTab(index: number) {
    this.selectedTab = index;
    this.tabSelect.emit(this.tabs[index].value)
  }

}
